import React from "react";

const useClickOutside = (callback: () => void) => {
    const ref = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                callback();
            }
        };
        document.addEventListener("mousedown", handleClickOutside, false);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [ref]);

    return ref;
};

export default useClickOutside;
